import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Braun Equipment"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { org.braunequip.web.pages.HomePage() }
        ctx.router.register("/braunadmin/") { org.braunequip.web.pages.braunadmin.AdminHomePage() }
        ctx.router.register("/braunadmin/assets") {
                org.braunequip.web.pages.braunadmin.AdminAssetsPage() }
        ctx.router.register("/braunadmin/assets/{id}") {
                org.braunequip.web.pages.braunadmin.AdminAssetDetailsPage() }
        ctx.router.register("/braunadmin/employees") {
                org.braunequip.web.pages.braunadmin.AdminEmployeesPage() }
        ctx.router.register("/braunadmin/login") {
                org.braunequip.web.pages.braunadmin.LoginAdminPage() }
        ctx.router.register("/braunadmin/maintenance") {
                org.braunequip.web.pages.braunadmin.AdminMaintenancePage() }
        ctx.router.register("/careers") { org.braunequip.web.pages.CareersPage() }
        ctx.router.register("/contactus") { org.braunequip.web.pages.ContactUsPage() }
        ctx.router.register("/employeeportal") { org.braunequip.web.pages.EmployeePortalPage() }
        ctx.router.register("/equipment-services") {
                org.braunequip.web.pages.EquipmentServicesPage() }
        ctx.router.register("/freight-brokering") { org.braunequip.web.pages.FreightBrokeringPage()
                }
        ctx.router.register("/oops") { org.braunequip.web.pages.OnTheWayPage() }
        ctx.router.register("/trucking") { org.braunequip.web.pages.TruckingPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("lightbox", org.braunequip.web.components.bulma.lightboxStyle)
        ctx.theme.registerStyle("markdown", org.braunequip.web.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("admin-page-content",
                org.braunequip.web.components.layouts.AdminPageContentStyle)
        ctx.theme.registerStyle("footer", org.braunequip.web.components.sections.FooterStyle)
        ctx.theme.registerStyle("contact-details-container",
                org.braunequip.web.components.sections.ContactDetailsContainer)
        ctx.theme.registerStyle("address-contact-column",
                org.braunequip.web.components.sections.addressContactColumn)
        ctx.theme.registerStyle("footer-focused",
                org.braunequip.web.components.sections.footerFocusedStyle)
        ctx.theme.registerStyle("hours-title", org.braunequip.web.components.sections.hoursTitle)
        ctx.theme.registerStyle("table", org.braunequip.web.components.sections.tableStyle)
        ctx.theme.registerStyle("hours", org.braunequip.web.components.sections.hoursStyle)
        ctx.theme.registerStyle("nav-header", org.braunequip.web.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("nav-header-logo",
                org.braunequip.web.components.sections.NavHeaderLogo)
        ctx.theme.registerStyle("nav-link", org.braunequip.web.components.sections.NavLinkStyle)
        ctx.theme.registerStyle("nav-link-container",
                org.braunequip.web.components.sections.NavLinkContainerStyle)
        ctx.theme.registerStyle("nav-link-slide-background",
                org.braunequip.web.components.sections.NavLinkSlideBackground)
        ctx.theme.registerStyle("signature-canvas",
                gr.tech.lkpksignature.components.SignaturePad.signatureCanvasStyle)
        ctx.theme.registerStyle("basic-button",
                gr.tech.lkpksignature.components.SignaturePad.basicButtonStyle)
        ctx.theme.registerStyle("rental-card-container",
                org.braunequip.web.components.widgets.RentalCardContainer)
        ctx.theme.registerStyle("rental-card",
                org.braunequip.web.components.widgets.RentalCardStyle)
        ctx.theme.registerStyle("rental-image-container",
                org.braunequip.web.components.widgets.RentalImageContainer)
        ctx.theme.registerStyle("rental-image",
                org.braunequip.web.components.widgets.RentalImageStyle)
        ctx.theme.registerStyle("rental-name-title",
                org.braunequip.web.components.widgets.RentalNameTitle)
        ctx.theme.registerStyle("rental-name-subtitle",
                org.braunequip.web.components.widgets.RentalNameSubtitle)
        ctx.theme.registerStyle("service-card-container",
                org.braunequip.web.components.widgets.ServiceCardContainer)
        ctx.theme.registerStyle("service-card",
                org.braunequip.web.components.widgets.ServiceCardStyle)
        ctx.theme.registerStyle("service-card-desc-overlay",
                org.braunequip.web.components.widgets.ServiceCardDescOverlay)
        ctx.theme.registerStyle("service-card-title",
                org.braunequip.web.components.widgets.ServiceCardTitleStyle)
        ctx.theme.registerStyle("service-card-desc",
                org.braunequip.web.components.widgets.ServiceCardDescStyle)
        ctx.theme.registerStyle("admin-title-header",
                org.braunequip.web.styles.AdminStyles.AdminTitleHeaderStyle)
        ctx.theme.registerStyle("admin-subtitle-header",
                org.braunequip.web.styles.AdminStyles.AdminSubtitleHeaderStyle)
        ctx.theme.registerStyle("admin-description",
                org.braunequip.web.styles.AdminStyles.AdminDescriptionStyle)
        ctx.theme.registerStyle("admin-details-column",
                org.braunequip.web.styles.AdminStyles.AdminDetailsColumnStyle)
        ctx.theme.registerStyle("table-header",
                org.braunequip.web.styles.AdminStyles.TableHeaderStyle)
        ctx.theme.registerStyle("table-row-hover",
                org.braunequip.web.styles.AdminStyles.TableRowHoverStyle)
        ctx.theme.registerStyle("show-more-button",
                org.braunequip.web.styles.AdminStyles.ShowMoreButtonStyle)
        ctx.theme.registerStyle("update-modal",
                org.braunequip.web.styles.AdminStyles.UpdateModalStyle)
        ctx.theme.registerStyle("loading-circle",
                org.braunequip.web.styles.AdminStyles.LoadingCircleStyle)
        ctx.theme.registerStyle("hover-success-button",
                org.braunequip.web.styles.AdminStyles.HoverSuccessButton)
        ctx.theme.registerStyle("hover-warning-button",
                org.braunequip.web.styles.AdminStyles.HoverWarningButton)
        ctx.theme.registerStyle("hover-bad-button",
                org.braunequip.web.styles.AdminStyles.HoverBadButton)
        ctx.theme.registerStyle("headline-text", org.braunequip.web.styles.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", org.braunequip.web.styles.SubheadlineTextStyle)
        ctx.theme.registerStyle("centered-section", org.braunequip.web.styles.centeredSection)
        ctx.theme.registerStyle("capped-width", org.braunequip.web.styles.cappedWidth)
        ctx.theme.registerStyle("resp-split-container",
                org.braunequip.web.styles.RespSplitContainer)
        ctx.theme.registerStyle("resp-button", org.braunequip.web.styles.RespButtonStyle)
        ctx.theme.registerStyle("page-hero-container", org.braunequip.web.styles.PageHeroContainer)
        ctx.theme.registerStyle("page-hero-section-row",
                org.braunequip.web.styles.PageHeroSectionRow)
        ctx.theme.registerStyle("page-hero-headline",
                org.braunequip.web.styles.PageHeroHeadlineStyle)
        ctx.theme.registerStyle("section-container", org.braunequip.web.styles.SectionContainer)
        ctx.theme.registerStyle("section-title-row", org.braunequip.web.styles.SectionTitleRow)
        ctx.theme.registerStyle("section-subtitle-row",
                org.braunequip.web.styles.SectionSubtitleRow)
        ctx.theme.registerStyle("equipment-hero-bg", org.braunequip.web.styles.equipmentHeroBg)
        ctx.theme.registerStyle("rental-description-container",
                org.braunequip.web.styles.RentalDescriptionContainer)
        ctx.theme.registerStyle("freight-brokering-bg",
                org.braunequip.web.styles.freightBrokeringBg)
        ctx.theme.registerStyle("split-hero-column", org.braunequip.web.styles.SplitHeroColumn)
        ctx.theme.registerStyle("small-pdf-box", org.braunequip.web.styles.smallPDFBoxStyle)
        ctx.theme.registerStyle("small-list", org.braunequip.web.styles.smallListStyle)
        ctx.theme.registerStyle("hero-align", org.braunequip.web.styles.HeroAlign)
        ctx.theme.registerStyle("call-column", org.braunequip.web.styles.CallColumn)
        ctx.theme.registerStyle("lineup-bg", org.braunequip.web.styles.lineupBg)
        ctx.theme.registerStyle("cta-button", org.braunequip.web.styles.CTAButtonStyle)
        ctx.theme.registerStyle("service-container",
                org.braunequip.web.styles.ServiceContainerStyle)
        ctx.theme.registerStyle("partners-container",
                org.braunequip.web.styles.PartnersContainerStyle)
        ctx.theme.registerStyle("partner-image", org.braunequip.web.styles.PartnerImageStyle)
        ctx.theme.registerStyle("login-input", org.braunequip.web.styles.LoginInputStyle)
        ctx.theme.registerStyle("trucking-hero-bg", org.braunequip.web.styles.truckingHeroBg)
        ctx.theme.registerStyle("services-container", org.braunequip.web.styles.servicesContainer)
        ctx.theme.registerStyle("services-block", org.braunequip.web.styles.servicesBlock)
        ctx.theme.registerVariant("-circle", org.braunequip.web.styles.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", org.braunequip.web.styles.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in",
                org.braunequip.web.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("loading-spinner",
                org.braunequip.web.components.widgets.loadingSpinnerAnimation)
        org.braunequip.web.styles.initSiteStyles(ctx)
        org.braunequip.web.styles.initTheme(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "root") {
        org.braunequip.web.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
